import { render } from "./KeyNumbers.vue?vue&type=template&id=54361524&scoped=true&ts=true"
import script from "./KeyNumbers.vue?vue&type=script&lang=ts"
export * from "./KeyNumbers.vue?vue&type=script&lang=ts"

import "./KeyNumbers.vue?vue&type=style&index=0&id=54361524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54361524"]])

export default __exports__